import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'enum2Array',
})
export class Enum2ArrayPipe implements PipeTransform {
    transform(data: Object) {
        return Object.entries(data)
            .filter((x: any) => !isNaN(x[0])).map((x: any) => {
                return { key: parseInt(x[0], 10), value: x[1] };
            });
    }
}
